
import {PageManager} from '@mvps-genesis/bootstrap';
import ProductImageGallery from 'extensions/product-image-gallery';

/**
 * Base class for product pages. Contains a Collection of common methods
 * shared across product pages (ie PROD, PROD_MULTI, PROD_MIX, etc).
 */
export default class ProductBase extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	async initAltStickyHeader () {
		const stickyHeaderElement = document.getElementById('js-sticky-header');

		if (!stickyHeaderElement || !('IntersectionObserver' in window)) {
			return;
		}

		const {default: ProductStickyHeader} = await import('extensions/product-sticky-header');

		new ProductStickyHeader(stickyHeaderElement);

		const headerCtaElement = document.getElementById('js-product-header-cta-control');
		const purchaseContainerElement = document.getElementsByClassName('g-product-layout-purchase')[0];

		if (!headerCtaElement || !purchaseContainerElement) {
			return;
		}

		headerCtaElement.addEventListener('click', (event) => {
			event.preventDefault();

			purchaseContainerElement.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		});
	}

	initImageGallery () {
		const imageSliderElement = document.getElementById('js-product-layout-image-slider');

		if (!imageSliderElement) {
			return;
		}

		new ProductImageGallery({
			productLayoutImageSlider: imageSliderElement,
			videos: this.pageContext.Product_Videos || []
		});
	}

	async initQNA () {
		const qnaContainerElement = document.getElementById('js-product-qna');

		if (!qnaContainerElement) {
			return;
		}

		const {QNA} = await import('custom-extensions/qna');

		new QNA({
			containerElement: qnaContainerElement
		});

		const formElement = document.getElementById('js-qna-form');

		if (!formElement) {
			return;
		}

		const actionInputElement = formElement.querySelector('input[name="Action"]');
		const botInputElement = formElement.querySelector('.js-bot-verification');

		formElement.addEventListener('submit', (event) => {
			event.preventDefault();

			if (botInputElement.value) {
				window.location.href = window.location.origin;
			} else {
				actionInputElement.value = 'ASKQ';

				event.target.submit();
			}
		});
	}

	async initTabcordion () {
		const tabcordionElement = document.getElementsByClassName('g-tabcordion')[0];

		if (!tabcordionElement) {
			return;
		}

		const {Tabcordion} = await import('extensions/tabs');

		new Tabcordion(tabcordionElement, {
			accordionMode: 768,
			hashOptions: {
				enabled: true,
				scrollIntoView: {
					behavior: 'smooth',
					block: 'start'
				},
				updateLocation: true
			}
		});
	}

	async initTooltips () {
		const tooltipElements = document.querySelectorAll('.js-tooltip');

		if (!tooltipElements) {
			return;
		}

		const {default: tippy} = await import('tippy.js');
		await import('tippy.js/dist/tippy.css');

		tippy(tooltipElements, {
			allowHTML: true
		});
	}

	removeCloseupBackingElement () {
		const closeupBackingElement = document.querySelector('div.closeup_backing');

		if (!closeupBackingElement) {
			return;
		}

		window.addEventListener('load', function () {
			closeupBackingElement.parentNode.removeChild(closeupBackingElement);
		});
	}

}
